import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import formServices from 'services/form-builder-services'
import toast from 'react-hot-toast'
import { dlTrackEvent } from 'components/dataLayer/dataLayer'
import textServices from 'services/text-services'
import { SelectGender } from 'theme/theme'
import { useEffect } from 'react'
import Input from "components/input";

interface IProps {
  city: any
  state: any
  neighborhood: any
  onSubmit: (getValues: () => any) => Promise<void>
  defaultValues: { city: string, state: number, neighborhood: string }
  getValuesStep: (name?: string) => any
}

const EditAddressStep2 = ({ onSubmit, city, state, neighborhood, defaultValues, getValuesStep }: IProps) => {
  const { handleSubmit, setValue, getValues, register, formState: { errors } } = useForm({
    resolver: yupResolver(formServices.formGenerateSchema(["neighborhood"])),
    criteriaMode: 'firstError',
    reValidateMode: 'onSubmit',
    mode: 'all'
  })

  useEffect(() => {
    if (defaultValues) {
      setValue('neighborhood', defaultValues.neighborhood)
      setValue('city', defaultValues.city)
      setValue('state', defaultValues.state)
    }
  }, [defaultValues])

  const handleConfirm = async () => {
    dlTrackEvent('form_send', {
      element: 'verificar',
      form_name: 'address',
      section: 'cambio de direccion'
    })
    await onSubmit(getValues)
  }

  const onInvalid = (errors: Record<string, any>) => {
    if (errors) {
      const errorsKeys = Object.values(errors)
      toast.error(errorsKeys[0]?.message, { className: 'toast__error' })
    }
  };

  return (
    <div className="pb-4">
      <h2 className="form__sign-in__title">Editar dirección</h2>
      <p className="description big font-bold text-center mb-6">
        {textServices.findByText('update/street/street', { es: 'Calle', en: 'Street' })} {`${getValuesStep('street1')} ${getValuesStep('streetNumber')}` || textServices.findByText('notInformation', { es: 'Sin información', en: 'No information' })}, <br />
        {city?.name || textServices.findByText('notInformation', { es: 'Sin información', en: 'No information' })}, <br />
        {state?.name || textServices.findByText('notInformation', { es: 'Sin información', en: 'No information' })}, <br />
        {textServices.findByText('update/street/cp', { es: 'CP:', en: 'CP - Postal code:' })} {getValuesStep('postalCode') || textServices.findByText('notInformation', { es: 'Sin información', en: 'No information' })}
      </p>
      <p className="text big text-center mb-8">Si es correcto, completa los últimos datos y dale a actualizar. Ya falta poco.</p>
      <form onSubmit={handleSubmit(handleConfirm, onInvalid)} className='space-y-4'>
        <div className={`gap-2 flex flex-col input-container ${errors?.neighborhood?.message ? 'error-input' : ''}`}>
          <SelectGender
            name="neighborhood"
            className="text-black w-full h-16 din p-4 pr-7 input-select"
            {...register("neighborhood")}
          >
            {neighborhood.map((neighborhood: any) => (
              <option value={neighborhood.id} key={`${neighborhood?.name}-${neighborhood?.id}`}>
                {neighborhood?.name}
              </option>
            ))}
          </SelectGender>
        </div>
        <div className={`gap-2 flex flex-col input-container ${errors?.city?.message ? 'error-input' : ''}`}>
          <Input
            className="text-center saira font-bold text-sm"
            type="text"
            placeholder={textServices.findByText('profile/form/information/city/placeholder', { es: "Municipio", en: 'City' })}
            name="city"
            {...register("city")}
            disabled
          />
        </div>
        <div className={`gap-2 flex flex-col input-container ${errors?.state?.message ? 'error-input' : ''}`}>
          <Input
            className="text-center saira font-bold text-sm"
            type="text"
            placeholder={textServices.findByText('profile/form/information/state/placeholder', { es: "Estado", en: 'State' })}
            name="state"
            {...register("state")}
            disabled
          />
        </div>
        <div className='space-y-4 flex flex-col items-center'>
          <button type="submit" className="form__sign-in__btn form__sign-in__btn__main">
            Guardar cambios
          </button>
        </div>
      </form>
    </div>
  )
}

export default EditAddressStep2